import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
// plugin registry gsap
gsap.registerPlugin(ScrollToPlugin);

export default class{

    constructor(options) {

        this.defaults = {
        	main 		: undefined,
            $el         : []
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'gravity-forms-control';
		this.main			= this.options.main;
        this.$el            = this.options.$el;

        if ( this.$el.length > 0 ){
            this.init( true );
        }
		
    }

    init( b ){

    	if ( b ){
            this.$el.find( '.gform_wrapper' ).append( this.$el.find( '.spinner-holder') );
            this.$form = this.$el.find( 'form' );
            this.id = this.$form.attr( 'id' ).split( '_' )[1];
            this.$response = this.$el.find( '.response' );
        }

        if ( this.$form.length > 0){
            this.addEvents(b);
            this.addGravityPlaceholdersScript( b );
            this.skin( b );
            this.setSpecialCases();
        }

        this.$el.addClass( 'ready' )
    }

    addEvents(b){
        if( b ){
            this.$form.on( 'submit', (e)=>this.ajaxifyForm(e) );
            this.$el.find( 'input' ).on( 'focus', (e)=>this.onInputChange(e) );
            this.$form.find( 'input[type="submit"]' ).on( 'click', (e)=>this.$form.submit() );
            this.$el.on( 'click', ()=>this.openResponse(false) );
        }
        else{
            this.$form.off( 'submit', (e)=>this.ajaxifyForm(e) );
            this.$form.find( 'input[type="submit"]' ).off( 'click', (e)=>this.$form.submit() );
            this.$el.off( 'click', ()=>this.openResponse(false) );
            this.$el.find( 'input' ).off( 'focus', (e)=>this.onInputChange(e) );
        }
    }

    onInputChange( e ){
        let $el = $(e.currentTarget), $li;
        if ( $el.length > 0 ){
            $li = $el.parents( 'li.gfield' );
            if ( $li.length > 0 ){
                if ( $li.hasClass( 'gfield_error' ) ){
                    $li.removeClass( 'gfield_error' );
                }
            }
        }
    }

    clearFields(){
        this.$form.find( '.gform_body input' ).val( '' );
    }

    ajaxifyForm(e){

        let $response;

        e.preventDefault();

        if ( this.submit ){
            return;
        }
        this.submit = true;

        this.setLoading( true );
        
        $.ajax({
           type:    this.$form.attr( 'method' ),
           url:     this.$form.attr( 'action' ),
           data:    this.$form.serialize()
        })
        .done( ( data )=>{
            $response = $(data).find( '#' + this.$form.attr( 'id' ) );
            if ( $response.length > 0 ){
                this.parseErrors( $response );
            }
            else{
                // tutto ok ...
                this.confirm( data );
            }                   
        })
        .fail( ( jqXHR, textStatus )=>{

            this.setResponse( 'Request failed: ' + textStatus );

        })
        .always( ( data )=>{
             this.setLoading( false );
             this.submit = false;
        });

    }

    parseErrors( $response ){
        if ( $response.find( '.validation_error' ).length > 0 ){
            $response.find( '.gfield_error' ).each( (i, el ) => {
                this.$form.find( '#' + $(el).attr( 'id' ) ).addClass( 'gfield_error' ); 
            });

            this.setResponse( $response.find( '.validation_error' ).html() );
        }
    }

    confirm( data ){
        let $response = $(data).find( '#gform_confirmation_wrapper_' + this.id );

        this.clearFields();
        this.setResponse( $response.find( '.gform_confirmation_message' ).html() );
    }

    setResponse( message ){
        this.$response.find( '.message' ).html( message );
        this.openResponse( true );
    }

    openResponse(b){
        if ( b ){
            if ( !this.$response.hasClass( 'active' )){
                this.$response.addClass( 'active' );
            }
        }
        else{
            if ( this.$response.hasClass( 'active' )){
                this.$response.removeClass( 'active' );
            }
        }
    }

    setLoading( b ){
        this.main.setLoading( b );
        if ( b ){
            this.$el.addClass( 'loading' );
        }
        else{
            this.$el.removeClass( 'loading' );
        }
    }

    addGravityPlaceholdersScript( b ){
        if ( b ){
            $(document).bind('gform_post_render', (event, formId, currentPage)=>{
                if(formId == this.id) {
                    if(typeof Placeholders != 'undefined'){
                        Placeholders.enable();
                    }
                } 
            });
            //$(document).bind('gform_post_conditional_logic', (event, formId, fields, isInit)=>{} );
            $(document).trigger('gform_post_render', [this.id, 1] );       
        }
        else{
            $(document).unbind('gform_post_render', (event, formId, currentPage)=>{
                if(formId == this.id) {
                    if(typeof Placeholders != 'undefined'){
                        Placeholders.enable();
                    }
                } 
            });
            //$(document).unbind('gform_post_conditional_logic', (event, formId, fields, isInit)=>{} );
        }         
    }

    skin(b){
        if ( b ){
            this.skinRadioAndCheckboxes();
        }
    }

    skinRadioAndCheckboxes(){
        // https://lokesh-coder.github.io/pretty-checkbox/
        // skin radio and checkboxes with pretty-checkbox css
        let $cs = this.$form.find( 'input[type="checkbox"]' ), 
            _class = 'p-default p-round p-smooth', 
            $c;

        //1) Checkboxes
        // wrap input and label with div pretty
        if ( $cs.length > 0 ){
            $cs.each( (i, el) =>{
                $c = $(el);
                $c.next( 'label' ).addBack().wrapAll( '<div class="pretty ' + _class + '" />' );
            });
        }

        // 2) Radios
        $cs = this.$form.find( 'input[type="radio"]' );

        if ( $cs.length > 0 ){
            $cs.each( (i, el) =>{
                $c = $(el);
                $c.next( 'label' ).addBack().wrapAll( '<div class="pretty ' + _class + '" />' );
            });
        }

        // 3) Now .. all of them
        // add states ( wrap label with div state )
        $cs = this.$form.find( '.pretty' );
        if ( $cs.length > 0 ){
            $cs.each( (i, el) =>{
                $c = $(el);
                $c.find( 'label' ).wrap(  '<div class="state p-primary" />' );
            });
        }
    }

    setSpecialCases(){
        
        // contact form
        if ( this.$form.attr( 'id' ) === 'gform_3' ){
            let hash = document.location.hash, scroll = false;
            if( hash === '#support' ){
                this.$form.find( '.gfield_radio li:eq(1) input' ).click();
                scroll = true;
            }
            else if ( hash === '#other'  ){
                 this.$form.find( '.gfield_radio li:eq(4) input' ).click();
                 scroll = true;
            }
            if ( scroll ){
                gsap.to( $(window), {duration: 0.4, scrollTo: this.$form.offset().top });
            }
        }
    }


    destroy(){
        if ( this.$el.length > 0 ){
            this.init( false );
        }
    }

}



